// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__mtvu7","content":"styles_content__19LyR","checkbox":"styles_checkbox__3KRLh","checkboxLabel":"styles_checkboxLabel__G3UGL"};